import React from "react";

const DataKIR = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Pengujian Kendaraan Bermotor"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=151&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5ODc2ODU2LCJJZGVudGl0eSI6MTUxLCJUb2tlblR5cGUiOjB9.XAzKsOwhYBbrnJ1ESHWWek1lFu1wykoTuormVLyxPVA&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
    
  );
};

export default DataKIR;
